'use strict';

/*globals isEmpty*/
/*globals services*/
/*globals blockElement*/
/*globals unBlockElement*/

(function ($) {
    var padding = 10;
    var $previewTooltipBox = $('<div id="preview-tooltip-box"></div>');

    $('body').append($previewTooltipBox);

    function changeTooltipBoxPosition($parent) {
        var offsetX = $parent.width() / 2;
        var offsetY = $parent.height();

        var windowWidth = $('body').prop('clientWidth');

        var x = $parent.offset().left + offsetX - ($previewTooltipBox.outerWidth() / 2);
        var y = $parent.offset().top  + offsetY;

        if(windowWidth < (x + $previewTooltipBox.outerWidth() + padding)) {
            x = windowWidth - $previewTooltipBox.outerWidth() - padding;
        }

        if((x - padding) < 0) {
            x = padding;
        }

        $previewTooltipBox.css('left', x).css('top', y);
    }

    var methods = {
        init: function (options) {
            var opts = $.extend({}, $.fn.previewTooltip.defaults, options);

            return this.each(function () {
                var _this = this;
                var $this = $(this);

                if ($this.hasClass('preview-tooltip-init')) {
                    return;
                }

                $this.addClass('preview-tooltip-init');

                $this.on('mouseenter', function (e) {
                    methods.show.apply(_this, [e]);
                });

                $this.on('mouseleave', function (e) {
                    methods.hide.apply(_this, [e]);
                });

                if(opts.init) {
                    opts.init.apply(_this);
                }
            });
        },

        show: function () {
            var $this = $(this);

            var data = $this.data('preview_tooltip_data');

            if(!isEmpty(data)) {
                $previewTooltipBox.html(data);
                $previewTooltipBox.show();
                changeTooltipBoxPosition($this);

                return;
            }

            var url = $this.data('preview_tooltip_url');

            if(!isEmpty(url)) {
                $previewTooltipBox.html('');
                $previewTooltipBox.show();
                changeTooltipBoxPosition($this);                

                blockElement($previewTooltipBox);
                $.getCORS(url, function (res) {
                    unBlockElement($previewTooltipBox);
                    try {
                        res = JSON.parse(res);
                        if(res.msg === 'SUCCESS') {
                            $this.data('preview_tooltip_data', res.data.html);
                            $previewTooltipBox.html(res.data.html);
                            changeTooltipBoxPosition($this);
                        } else {
                            services.get('development').viewSiteErrorMsg(res);
                        }
                    } catch(e) {
                        services.get('development').viewSiteErrorMsg(res, e);
                    }
                });
            }
        },

        hide: function () {
            $previewTooltipBox.hide();
        }
    };

    $.fn.previewTooltip = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exists on jQuery.previewTooltip');
        }
    };

    $.fn.previewTooltip.defaults = {};
})(jQuery);
